import Highcharts from "./customHighCharts";
import { applyCustomColors } from "./customHighchartBlueColor";

export const wordCloudChartConfig = (data, options = {}) => {
  // Apply custom colors if provided, otherwise use default Highcharts colors
  const customColors = applyCustomColors(options.color);
  const isClickable = !!(options.onWordClick || options.contributionsUrl);

  // Accept either an Array of points or an object { series: [...] }
  const points = Array.isArray(data) ? data : (data && data.series) || [];

  // Transform data format: {text, weight, frequency} to Highcharts structure
  const seriesData = points.map(item => ({
    name: item.text,
    weight: item.weight,
    frequency: item.frequency
  }));

  return {
    chart: {
      type: "wordcloud",
      backgroundColor: "transparent"
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        const docFreq = this.point.frequency;
        const mentions = options.tooltipMentionsLabel;
        const contributions = options.tooltipContributionsLabel;
        return `<b>${this.point.name}</b><br/>${mentions} <b>${docFreq}</b> ${contributions}`;
      }
    },
    plotOptions: {
      wordcloud: {
        cursor: isClickable ? "pointer" : "default",
        point: {
          events: {
            click: function () {
              if (!isClickable) return;
              // The onWordClick callback is used to navigate to the contributions search
              // view, initialize the search terms, and scroll to the contributions section.
              if (options.onWordClick) {
                options.onWordClick(this.name);
              } else if (options.contributionsUrl) {
                // Admin: Navigate to contributions with URL parameter
                const word = encodeURIComponent(this.name);
                const searchParam = options.useRansackSearch
                  ? `q[search_index_content_cont]=${word}`
                  : `search=${word}`;
                window.location.href = `${options.contributionsUrl}?${searchParam}`;
              }
            }
          }
        }
      }
    },
    series: [
      {
        type: "wordcloud",
        data: seriesData,
        name: null,
        // Wordcloud specific options
        rotation: {
          from: 0,
          to: 0,
          orientations: 1 // Keep all words horizontal for better readability
        },
        spiral: "rectangular",
        style: {
          fontFamily: "inherit",
          fontWeight: "600"
        },
        minFontSize: 10,
        maxFontSize: 48,
        placementStrategy: "random" // Better distribution across available space
      }
    ],
    colors: customColors
  };
};

const wordCloudChart = (element, data, options = {}) => {
  // Return null if no data
  if (!data || data.length === 0) {
    return null;
  }

  return Highcharts.chart(element, wordCloudChartConfig(data, options));
};

export default wordCloudChart;
